var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (view) {
buf.push("<form id=\"basic-info-form\" class=\"modal-body\"><div class=\"modal-body-content\"><h4><span data-i18n=\"signup.sso_connected\"></span></h4><div class=\"small m-y-1\">");
var ssoUsed = view.signupState.get('ssoUsed');
if ( ssoUsed === 'facebook')
{
buf.push("<img src=\"/images/pages/modal/auth/facebook_small.png\">");
}
if ( ssoUsed === 'gplus')
{
buf.push("<img src=\"/images/pages/modal/auth/gplus_small.png\">");
}
buf.push("<b class=\"m-x-1\"><span>" + (jade.escape(null == (jade_interp = view.signupState.get('email')) ? "" : jade_interp)) + "</span></b><span class=\"glyphicon glyphicon-ok-circle class-code-valid-icon\"></span></div><div class=\"hr-text m-y-3\"><hr><span data-i18n=\"common.next\"></span></div><div class=\"form-container\"><input name=\"email\"" + (jade.attr("value", view.signupState.get('email'), true, true)) + " class=\"hidden\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-7 col-xs-offset-3\"><label for=\"username-input\" class=\"control-label\"><span data-i18n=\"general.username\"></span></label></div><div class=\"col-xs-5 col-xs-offset-3\"><input id=\"username-input\" name=\"name\"" + (jade.attr("value", view.signupState.get('signupForm').name, true, true)) + " class=\"form-control input-lg\"></div><div class=\"col-xs-4 name-check\">");
var checkNameState = view.state.get('checkNameState');
if ( checkNameState === 'checking')
{
buf.push("<span data-i18n=\"signup.checking\" class=\"small\"></span>");
}
if ( checkNameState === 'exists')
{
buf.push("<span class=\"small\"><span class=\"text-burgundy glyphicon glyphicon-remove-circle\"></span>" + (jade.escape(null == (jade_interp = " ") ? "" : jade_interp)) + "<span>" + (jade.escape(null == (jade_interp = view.state.get('suggestedNameText')) ? "" : jade_interp)) + "</span></span>");
}
if ( checkNameState === 'available')
{
buf.push("<span class=\"small\"><span class=\"text-forest glyphicon glyphicon-ok-circle\"></span>" + (jade.escape(null == (jade_interp = " ") ? "" : jade_interp)) + "<span data-i18n=\"signup.name_available\"></span></span>");
}
buf.push("</div></div></div><div class=\"form-group subscribe\"><div class=\"row\"><div class=\"col-xs-7 col-xs-offset-3\"><div class=\"checkbox\"><label><input id=\"subscribe-input\" type=\"checkbox\" name=\"subscribe\"" + (jade.attr("checked", view.signupState.get('signupForm').subscribe[0] === 'on', true, true)) + "><span data-i18n=\"signup.email_announcements\"></span></label></div></div></div></div></div></div><!-- In reverse order for tabbing purposes--><div class=\"history-nav-buttons\">");
if ( view.signupState.get('path') === 'teacher')
{
buf.push("<button type=\"submit\" class=\"next-button btn btn-lg btn-navy\"><span data-i18n=\"common.next\"></span></button>");
}
else if ( view.signupState.get('subModalContinue'))
{
buf.push("<button id=\"create-account-btn\" type=\"submit\" class=\"next-button btn btn-lg btn-navy\"><span data-i18n=\"common.continue\"></span></button>");
}
else
{
buf.push("<button id=\"create-account-btn\" type=\"submit\" class=\"next-button btn btn-lg btn-navy\"><span data-i18n=\"login.sign_up\"></span></button>");
}
buf.push("<button type=\"button\" class=\"back-button btn btn-lg btn-navy-alt\"><span data-i18n=\"common.back\"></span></button></div></form>");}.call(this,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/single-sign-on-confirm-view.jade
// module id = 837
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91